import React, { Component } from 'react';
import ReportExternalComments from '../../Reports/ReportExternalComments';
class ExternalComments extends Component {
  renderFiles() {
    const { renderFiles } = this.props;
    return renderFiles ? renderFiles() : null;
  }

  renderExternalComments() {
    const { commentsFileList } = this.props;

    return (
      <>
        <ReportExternalComments />
        {commentsFileList?.commentsFileList?.length > 0 && this.renderFiles()}
      </>
    );
  }

  render() {
    return <>{this.renderExternalComments()}</>;
  }
}

export default ExternalComments;
